import {Empty, List, Skeleton} from "antd";
import {
    Button,
} from "~/components";
import {
    useEffect,
    useState
} from "react";
import {
    apiError,
    handleRequest, renderDate
} from "../../../../utils";
import {promotionApi} from "../../../../api";

function PromotionForm({openModal, promotions, setPromotions, setContractPromotions, closeModal})
{
    const [loading, setLoading] = useState(false);

    const [errorLoad, setErrorLoad] = useState(false);

    const eventHandlers = {
        load: async () => {

            if(openModal.promotion === true && promotions?.length === 0)
            {
                setLoading(true);

                let [error, response] = await handleRequest(promotionApi.get());

                let message = apiError(`Load chương trình thất bại`, error, response);

                if (!message)
                {
                    setPromotions(response.data);
                    setErrorLoad(false)
                }
                else
                {
                    setErrorLoad(true);
                }

                setLoading(false);
            }
        },
        chose: async (item) => {
            setContractPromotions((prevItems) => {
                const exists = prevItems.some(p => p.id === item.id);
                if (!exists) {
                    return [...prevItems, item];
                }
                return prevItems; // không thêm nếu trùng
            });
            closeModal('promotion')
        },
    }

    useEffect(() => {
        eventHandlers.load().then()
    }, [openModal.promotion])

    if(loading) {
        return (
            <Skeleton />
        )
    }

    if(errorLoad) {
        return (
            <Empty description={<span>Không có chương trình</span>}></Empty>
        )
    }

    return (
        <div className="form">
            <List
                itemLayout="horizontal"
                dataSource={promotions}
                renderItem={item => (
                    <List.Item
                        actions={[<Button background small blue onClick={()=>eventHandlers.chose(item)}>Chọn</Button> ]}
                    >
                        <List.Item.Meta
                            title={item.name}
                            description={renderDate(item.timeStart) + ' - ' + renderDate(item.timeEnd)}
                        />
                    </List.Item>
                )}
            />
            <hr />
            <div className="form-group d-flex justify-content-end modal-bottom">

            </div>
        </div>
    )
}

export default PromotionForm;